import { Button } from "@/components/ui/button";
import { PURCHASE_REASONS } from "@/hooks/useVehicleSim";
import { ArrowLeft, ArrowRight, Check } from "lucide-react";

interface Props {
  selectedReason: string | null;
  onSelect: (reason: string) => void;
  onContinue: () => void;
  onBack: () => void;
}

export default function NeedsCheckScreen({ selectedReason, onSelect, onContinue, onBack }: Props) {
  return (
    <div className="space-y-6">
      <div className="text-center space-y-2">
        <h2 className="font-heading text-lg font-bold text-foreground">Why Are You Buying a Vehicle?</h2>
        <p className="text-sm text-muted-foreground">Your reason will shape our recommendations throughout the process.</p>
      </div>

      <div className="space-y-2">
        {PURCHASE_REASONS.map(r => (
          <button
            key={r.key}
            onClick={() => onSelect(r.key)}
            className={`w-full text-left p-4 rounded-2xl border transition-all duration-200 flex items-center gap-3 ${
              selectedReason === r.key
                ? 'glass-card glow-border ring-2 ring-primary/30'
                : 'glass-card hover:shadow-card-hover'
            }`}
          >
            <span className="text-xl">{r.icon}</span>
            <span className="flex-1 text-sm font-medium text-foreground">{r.label}</span>
            {selectedReason === r.key && <Check className="w-4 h-4 text-primary" />}
          </button>
        ))}
      </div>

      <div className="flex gap-3">
        <Button variant="outline" onClick={onBack} className="gap-2"><ArrowLeft className="w-4 h-4" /> Back</Button>
        <Button onClick={onContinue} disabled={!selectedReason} className="flex-1 gap-2">Continue <ArrowRight className="w-4 h-4" /></Button>
      </div>
    </div>
  );
}
